import { render, staticRenderFns } from "./Type5Block.vue?vue&type=template&id=63ec1d6b&scoped=true&"
import script from "./Type5Block.vue?vue&type=script&lang=js&"
export * from "./Type5Block.vue?vue&type=script&lang=js&"
import style0 from "./Type5Block.vue?vue&type=style&index=0&id=63ec1d6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec1d6b",
  null
  
)

export default component.exports